/**
 * Production Logger
 * Environment-aware logging utility that only logs in development
 * Replaces console.log/warn/error for production safety
 */

const isDevelopment = process.env.NODE_ENV === 'development';

const logger = {
  /**
   * Debug logging (only in development)
   * @param {...any} args - Arguments to log
   */
  debug: (...args) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },

  /**
   * Info logging (only in development)
   * @param {...any} args - Arguments to log
   */
  info: (...args) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },

  /**
   * Warning logging (only in development for security)
   * @param {...any} args - Arguments to log
   */
  warn: (...args) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },

  /**
   * Error logging (only in development for security)
   * In production, errors should be sent to a monitoring service
   * @param {...any} args - Arguments to log
   */
  error: (...args) => {
    if (isDevelopment) {
      console.error(...args);
    }
    // TODO: In production, send errors to monitoring service (e.g., Sentry)
    // if (!isDevelopment) {
    //   sentryClient.captureException(args[0]);
    // }
  },

  /**
   * Log only in development
   * @param {...any} args - Arguments to log
   */
  dev: (...args) => {
    if (isDevelopment) {
      console.log('[DEV]', ...args);
    }
  },
};

export default logger;
